import { compose, withHandlers } from 'recompose';
import withTimeTrackingEnabled from './withTimeTrackingEnabled';
import { fetchShopTimeTrackingBarbers, fetchBarberTimeTrackingBarbers } from '../actions';
import { withActionByRole } from '../../../common/helpers/actions';

const withFetchTimeTrackingBarbers = compose(
  withTimeTrackingEnabled,
  withActionByRole('fetchTimeTrackingBarbers', fetchShopTimeTrackingBarbers, fetchBarberTimeTrackingBarbers),
  withHandlers({
    fetchTimeTrackingBarbers: props => (filters) => {
      if (!props.timeTrackingEnabled) return;
      props.fetchTimeTrackingBarbers(filters);
    },
  }),
);

export default withFetchTimeTrackingBarbers;
